import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const formatTimeInTimezone = (time?: string | null, timezoneName?: string) => {
  if (!time) return '-';
  if (!timezoneName) return '-';

  return dayjs(time).tz(timezoneName).format('YYYY-MM-DD HH:mm:ss');
};

export default formatTimeInTimezone;
